<template  >


    <v-container style="margin-top:60px;overflow:hidden;" >
        <v-card class="mx-auto" dark style="background:transparent;" flat>
            <div style="text-align: center;">Giveaway</div>
            <v-card-text style="text-align: center;">
                Gief hicards
            </v-card-text>






        </v-card>

        <v-row style="max-width: 800px;" class="mx-auto" justify="center" align="center" >
            <v-col cols="12"  >
                <v-card
                        dark
                        class="mx-auto"
                        style="padding: 20px;height:800px;width:100%;background: red;"
                >

                    <div style="" class="wheel-wrapper">
                        <div
                                class="wheel-pointer"
                                @click="onClickRotate"
                        >
                            Start
                        </div>
                        <div
                                class="wheel-bg"
                                style="pointer-events: none;overflow: hidden;"
                                :class="{freeze: freeze}"
                                :style="`transform: rotate(${wheelDeg}deg)`"
                        >
                            <div class="prize-list">
                                <div
                                        class="prize-item-wrapper"
                                        v-for="(item,index) in prizeList"
                                        :key="index"
                                >
                                    <div
                                            class="prize-item"
                                            :style="`transform: rotate(${(360/ prizeList.length) * index}deg)`"
                                    >
                                        <div class="prize-name">
                                            {{ item.name }}
                                        </div>
                                        <div class="prize-icon">
                                            <img :src="item.icon">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>






                </v-card>
            </v-col>


        </v-row>


    </v-container>

</template>

<script>


    export default {
        name: "Giveaway",
        components:{},
        data:function(){
            return {
                freeze: false,
                rolling: false,
                wheelDeg: 0,
                prizeNumber: 8,
                prizeListOrigin: [
                    {
                        icon: "https://picsum.photos/40?random=1",
                        name: "$10000"
                    },
                    {
                        icon: "https://picsum.photos/40?random=6",
                        name: "Thank you!"
                    },
                    {
                        icon: "https://picsum.photos/40?random=2",
                        name: "$500"
                    },
                    {
                        icon: "https://picsum.photos/40?random=3",
                        name: "$100"
                    },
                    {
                        icon: "https://picsum.photos/40?random=6",
                        name: "Thank you!"
                    },
                    {
                        icon: "https://picsum.photos/40?random=4",
                        name: "$50"
                    },
                    {
                        icon: "https://picsum.photos/40?random=5",
                        name: "$10"
                    },
                    {
                        icon: "https://picsum.photos/40?random=6",
                        name: "Thank you!"
                    }
                ]
            };
        },

        computed: {
            prizeList() {
                return this.prizeListOrigin.slice(0, this.prizeNumber);
            }
        },
        methods: {
            onClickRotate() {
                if (this.rolling) {
                    return;
                }
                const result = Math.floor(Math.random() * this.prizeList.length);
                this.roll(result);
            },
            roll(result) {
                console.log("rollin!");
                this.rolling = true;
                const { wheelDeg, prizeList } = this;
                this.wheelDeg =
                    wheelDeg -
                    wheelDeg % 360 +
                    10* 360 +
                    (360 - 360 / prizeList.length * result);
                setTimeout(() => {
                    this.rolling = false;
                    alert("Result：" + prizeList[result].name);
                }, 22500);
            }
        },
        watch: {
            prizeNumber() {
                this.freeze = true;
                this.wheelDeg = 0;

                setTimeout(() => {
                    this.freeze = false;
                }, 0);
            }
        }
    }




</script>

<style scoped type="SCSS">
    .wheel-wrapper {
        width: 700px;
        height: 700px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .wheel-pointer {
        width: 60px;
        height: 60px;
        border-radius: 1000px;
        background: yellow;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        line-height: 60px;
        z-index: 10;
        cursor: pointer;


    &::after {
         content: "";
         position: absolute;
         top: -32px;
         left: 50%;
         border-width: 0 8px 40px;
         border-style: solid;
         border-color: transparent transparent yellow;
         transform: translateX(-50%);
     }
    }
    .wheel-bg {
        width: 100%;
        height: 100%;
        border-radius: 1000px;
        overflow: hidden;
        transition: transform 22s cubic-bezier(.05,.06,.13,1.02);
        background: #7eef97;

    &.freeze {
         transition: none;
         background: red;
     }
    }

    .prize-list {
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;
    }

    .prize-item-wrapper {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 350px;
        height: 350px;
    }

    .prize-item {
        width: 100%;
        height: 100%;
        transform-origin: bottom;

    .prize-name {
        padding: 16px 0;
    }

    .prize-icon {
    }
    }


</style>
